import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = ({ isOpen, onClose }) => {
  const navItems = [
    { path: '/hpanel/dashboard', icon: 'fas fa-tachometer-alt', label: 'Dashboard' },
    { path: '/hpanel/candidates', icon: 'fas fa-user-graduate', label: 'Candidates' },
    { path: '/hpanel/employers', icon: 'fas fa-building', label: 'Employers' },
    { path: '/hpanel/jobs', icon: 'fas fa-briefcase', label: 'Jobs' },
    { path: '/hpanel/blogs', icon: 'fas fa-blog', label: 'Blogs' },
    { path: '/hpanel/admin-users', icon: 'fas fa-users-cog', label: 'Admin Users' },
  ];

  const aiTools = [
    { path: '/hpanel/ai-matching', icon: 'fas fa-robot', label: 'Matching Analytics' },
    { path: '/hpanel/performance', icon: 'fas fa-chart-line', label: 'Performance' },
    { path: '/hpanel/recommendations', icon: 'fas fa-magic', label: 'AI Recommendations' },
  ];

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-10 md:hidden"
          onClick={onClose}
        ></div>
      )}
      
      <aside className={`sidebar bg-white w-64 min-h-screen shadow-md fixed md:relative z-20 transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}`}>
        <nav className="mt-4 px-4">
          <div className="flex items-center">
            <img 
                src="/logo-light.png" 
                alt="Hunar Pool" 
                className="h-8 w-auto mx-auto mb-4" 
                draggable="false"
            />
          </div>

          <ul className="space-y-2">
            {navItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `flex items-center px-4 py-3 text-gray-100 rounded-lg hover:bg-gray-100 hover:text-primary transition-colors ${
                      isActive ? 'active-nav' : ''
                    }`
                  }
                >
                  <i className={`${item.icon} mr-3`}></i>
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
          
          <div className="mt-10 px-4">
            <h3 className="text-xs uppercase text-gray-500 font-semibold mb-2">AI Tools</h3>
            <ul className="space-y-2">
              {aiTools.map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `flex items-center px-4 py-3 text-gray-100 rounded-lg hover:bg-gray-100  hover:text-primary transition-colors ${
                        isActive ? 'active-nav' : ''
                      }`
                    }
                  >
                    <i className={`${item.icon} mr-3`}></i>
                    <span>{item.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;